// Imports
import React from "react"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { Carousel } from "react-responsive-carousel"
import { DeviceFrame } from "@molecules"

export const MobileCarousel = ({ selectedIndex, items }) => {
  return (
    <Carousel
      infiniteLoop={false}
      centerMode
      centerSlidePercentage={100}
      labels={false}
      showStatus={false}
      showArrows={false}
      showThumbs={false}
      showIndicators={false}
      selectedItem={selectedIndex}
    >
      {items.map((elem, index) => {
        return (
          <DeviceFrame fit key={index}>
            <video
              className="child"
              poster={elem.contentPoster.url}
              autoPlay
              muted
              loop
              playsInline
            >
              <source src={elem.content.url} type="video/mp4" />
            </video>
          </DeviceFrame>
        )
      })}
    </Carousel>
  )
}
